import { TeamConfig } from "@/global/hooks/useTeamConfig";
import { EventPackage, EventType } from "@/global/store/data/types";

export function isEventWithinSeatLimit(
  event: EventType,
  teamConfig: TeamConfig
) {
  const {
    purchaseSeatConfigs: { minSeatLimit },
  } = teamConfig;
  const { maxSeatLimit, seatsClaimed } = event;
  if (seatsClaimed == null || seatsClaimed == undefined) return true;
  if (maxSeatLimit - seatsClaimed >= minSeatLimit) return true;
  return false;
}

export function isEventValidInPackage(
  event: EventType,
  pkg: EventPackage | null,
  teamConfig: TeamConfig
) {
  const { isPackageEnabled, canRemovePackageGames } = teamConfig.packageConfigs;
  if (!isPackageEnabled) return true;
  if (pkg?.isBuildYourOwn) return true;

  const isEventInPkg = pkg?.events?.some((evt) => {
    return evt.eventCode == event.eventCode;
  });
  if (!isEventInPkg) return true;
  if (canRemovePackageGames && isEventInPkg) return true;

  return false;
}

export function getSoldOutLabelAndColor(
  event: EventType,
  teamConfig: TeamConfig
) {
  const primaryColor = teamConfig?.colors?.primary;
  const eventCardSettings = teamConfig?.uiConfigs?.eventCardSettings;
  const isSoldOut = !event?.hasInventory;
  if (isSoldOut) {
    const label = eventCardSettings?.soldOutTagLabel || "Sold Out";
    const color = eventCardSettings?.soldOutTagColor || primaryColor;
    return { label, color };
  }
  return { label: "", color: "" };
}
